import './MembersView.scss'

import ButtonSelect, {
  ButtonSelectItem,
  ButtonSelectSeparator
} from '../../../components/ButtonSelect/ButtonSelect'
import React, { useCallback, useEffect, useState } from 'react'
import { Route, withRouter } from 'react-router-dom'

import Avatar from '../../../components/Avatar/Avatar'
import Button from '../../../components/Button/Button'
import Icon from '../../../components/Icon/Icon'
import InviteMemberFormModal from './InviteMemberFormModal'
import PermissionsFormModal from './PermissionsFormModal'
import Table from '../../../components/Table/Table'
import TextField from '../../../components/TextField/TextField'
import t from '../../../helpers/i18n'

const MembersView = ({ history }) => {
  const [members, setMembers] = useState()

  const handleClose = useCallback(() => history.push('/soccer/members/'), [
    history
  ])
  const handleEdit = useCallback(
    (member) =>
      history.push('/soccer/members/' + member.member_id + '/permissions'),
    [history]
  )
  const handleInvite = useCallback(
    () => history.push('/soccer/members/invite'),
    [history]
  )

  useEffect(() => {
    setMembers({
      from: 1,
      to: 7,
      total: 7,
      list: [
        {
          member_id: 1,
          photo:
            'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRw7ONHLzdrWJgBTb6W33JEJDMonluDejVDuA&usqp=CAU',
          name: 'Kaiya Bothman',
          email: 'kaiya.bothman@altium.mx',
          role: 'ADMIN'
        },
        {
          member_id: 2,
          photo: '',
          name: 'Igor Yvashlikova',
          email: 'igor.y@test.com',
          role: 'COLLABORATOR'
        }
      ]
    })
  }, [])

  return (
    <div>
      <div className='members-view-header'>
        <div className='-title label-extra-large-basic'>
          {t('titles.Organization_Settings')}
        </div>
        <div className='-slash'>/</div>
        <div className='-title label-extra-large-semibold'>{t('titles.Members')}</div>
        <div className='-pagination'>
          {members &&
            t('?.%s - %s of %s', members.from, members.to, members.total)}
        </div>
        <div className='-search'>
          <TextField
            placeholder={t('placeholders.Search')}
            icon='searchIcon'
            size='field-sized'
          />
        </div>
        <div className='-separator' />
        <Button
          label={t('buttons.Invite')}
          type='dark'
          size='field-sized'
          icon='GetIcon'
          color='green'
          onClick={handleInvite}
        />
        <div className='-separator' />
        <div className='-help'>
          <Icon size={32} icon='HelpSupportIcon' />
        </div>
      </div>

      {members && (
        <div className='members-view-content'>
          <Table>
            <div className='-tr -header'>
              <div className='-td overline-label-medium-basic'></div>
              <div className='-td overline-label-medium-basic'></div>
              <div className='-td overline-label-medium-basic'></div>
              <div className='-td overline-label-medium-basic'>
                {t('labels.Member_name')}
              </div>
              <div className='-td overline-label-medium-basic'>
                {t('labels.Email')}
              </div>
              <div className='-td overline-label-medium-basic'>
                {t('labels.Role')} <Icon size={16} icon='HelpSupportIcon' />
              </div>
              <div className='-td overline-label-medium-basic'>
                {t('labels.Permissions')} <Icon size={16} icon='HelpSupportIcon' />
              </div>
            </div>
            {members.list.map((member, index) => (
              <div className='-tr' key={member.member_id}>
                <div className='-td'>{index + 1}</div>
                <div className='-td'>
                  <Icon size={16} icon='DiamondIcon' />
                </div>
                <div className='-td -photo'>
                  <Avatar
                    source={member.photo}
                    alternative={member.name}
                    size='field-sized'
                  />
                </div>
                <div className='-td'>{member.name}</div>
                <div className='-td'>{member.email}</div>
                <div className='-td -role'>
                  <ButtonSelect initialLabel={ROLES[member.role]}>
                    <ButtonSelectItem
                      value='OWNER'
                      label={ROLES['OWNER']}
                      selected={member.role === 'OWNER'}
                    />
                    <ButtonSelectItem
                      value='ADMIN'
                      label={ROLES['ADMIN']}
                      selected={member.role === 'ADMIN'}
                    />
                    <ButtonSelectItem
                      value='COLLABORATOR'
                      label={ROLES['COLLABORATOR']}
                      selected={member.role === 'COLLABORATOR'}
                    />
                    <ButtonSelectSeparator />
                    <ButtonSelectItem
                      label={t('buttons.Remove_collaborator')}
                      unselectable
                    />
                  </ButtonSelect>
                </div>
                <div className='-td'>
                  <Button
                    label={t('buttons.Edit_Access')}
                    size='small'
                    onClick={() => handleEdit(member)}
                  />
                </div>
              </div>
            ))}
          </Table>
        </div>
      )}
      <Route exact path='/soccer/members/:userId/permissions'>
        <PermissionsFormModal onCloseRequested={handleClose} />
      </Route>
      <Route exact path='/soccer/members/invite'>
        <InviteMemberFormModal onCloseRequested={handleClose} />
      </Route>
    </div>
  )
}

const ROLES = {
  OWNER: t('roles.Owner'),
  ADMIN: t('roles.Admin'),
  COLLABORATOR: t('roles.Collaborator')
}

export default withRouter(MembersView)
